<div class="item-container">
  <div class="headers">
    <span class="item">Type</span>
    <span class="item">Qty</span>
  </div>
  <div class="content" *ngFor="let material of materials">
    <span class="item">{{ findPackingId(material.packingID) }}</span>
    <span class="item">{{ material.amount }}</span>
  </div>
</div>
